var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"href":_vm.xlink}})])}
var staticRenderFns = []

export { render, staticRenderFns }